import React from 'react';
import PropTypes from 'prop-types';

const PaymentMethodSelector = ({ 
  selectedMethod, 
  onMethodChange, 
  isTunisianUser = false,
  loading = false 
}) => {
  const paymentMethods = [
    {
      id: 'flouci',
      name: 'Online Payment',
      description: 'Paiement en ligne sécurisé via Flouci',
      icon: '💳',
      available: true
    },
    {
      id: 'pay_on_delivery',
      name: 'Payer à la livraison',
      description: 'Pay when you receive your order',
      icon: '📦',
      available: isTunisianUser
    }
  ];

  const availableMethods = paymentMethods.filter(method => method.available);

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Méthode de paiement
      </h3>
      
      {loading ? (
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-600"></div>
          <span className="ml-2 text-gray-600">Détection de votre localisation...</span>
        </div>
      ) : (
        <div className="space-y-3">
          {availableMethods.map((method) => (
            <label
              key={method.id}
              className={`relative flex items-center p-4 border rounded-lg transition-all duration-200
                cursor-pointer
                ${selectedMethod === method.id ? 'border-yellow-500 bg-yellow-50 ring-2 ring-yellow-200' : 'border-gray-300 hover:border-gray-400 bg-white'}`}
            >
              <input
                type="radio"
                name="paymentMethod"
                value={method.id}
                checked={selectedMethod === method.id}
                onChange={e => onMethodChange(e.target.value)}
                className="sr-only"
                disabled={false}
              />
              
              <div className="flex items-center w-full">
                <div className="flex-shrink-0">
                  <span className="text-2xl mr-3">{method.icon}</span>
                </div>
                
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="text-base font-medium text-gray-900">
                        {method.name}
                      </h4>
                      <p className="text-sm text-gray-600">
                        {method.description}
                      </p>
                    </div>
                    
                    {selectedMethod === method.id && (
                      <div className="flex-shrink-0">
                        <div className="w-5 h-5 bg-yellow-600 rounded-full flex items-center justify-center">
                          <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </label>
          ))}
        </div>
      )}

      {isTunisianUser && (
        <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-green-800">
                <strong>Paiement à la livraison disponible !</strong> Vous pouvez payer en espèces lors de la réception de votre commande.
              </p>
            </div>
          </div>
        </div>
      )}

      {!isTunisianUser && !loading && (
        <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-blue-800">
                <strong>Paiement à la livraison</strong> disponible uniquement pour les clients en Tunisie.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

PaymentMethodSelector.propTypes = {
  selectedMethod: PropTypes.string.isRequired,
  onMethodChange: PropTypes.func.isRequired,
  isTunisianUser: PropTypes.bool,
  loading: PropTypes.bool
};

export default PaymentMethodSelector; 